export default __webpack_public_path__ + "static/media/sidebar-arrow-down.96d55dc7.svg";